import React, { useMemo } from 'react';
import { Radar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
    TooltipItem,
} from 'chart.js';
import { HealthGroupsData } from '../../../services/network/form30SectorCharts-api';
import styles from './HealthGroupsChart.module.css';

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

interface HealthGroupsChartProps {
    data: HealthGroupsData | null;
    sectorName?: string;
}

export const HealthGroupsChart: React.FC<HealthGroupsChartProps> = React.memo(({ data, sectorName }) => {
    // Проверяем, есть ли хоть какие-то данные
    const hasData = useMemo(() => {
        if (!data) return false;
        return (
            data.current_group_1 !== null ||
            data.current_group_2 !== null ||
            data.current_group_3 !== null ||
            data.current_group_4 !== null ||
            data.current_group_5 !== null
        );
    }, [data]);

    const chartData = {
        labels: ['1', '2', '3', '4', '5'],
        datasets: [
            {
                label: 'Количество детей',
                data: data ? [
                    data.current_group_1 || 0,
                    data.current_group_2 || 0,
                    data.current_group_3 || 0,
                    data.current_group_4 || 0,
                    data.current_group_5 || 0,
                ] : [0, 0, 0, 0, 0],
                backgroundColor: '#1A64A52B',
                borderColor: '#1A64A5',
                borderWidth: 2,
                pointBackgroundColor: '#1A64A5',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#1A64A5',
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
            r: {
                beginAtZero: true,
                ticks: {
                    display: true,
                },
                pointLabels: {
                    font: {
                        size: 14,
                        weight: 'bold' as const,
                    },
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function(context: TooltipItem<'radar'>) {
                        const label = `Группа ${context.label}`;
                        const value = context.parsed.r || 0;
                        return `${label}: ${value}`;
                    }
                }
            }
        },
    };

    return (
        <div className={styles.chartContainer}>
            <h3 className={styles.chartTitle}>
                Группы здоровья
                {sectorName && <span className={styles.sectorName}> - {sectorName}</span>}
            </h3>
            <div className={styles.chartWrapper}>
                {hasData ? (
                    <Radar data={chartData} options={options} />
                ) : (
                    <div className={styles.noData}>
                        <p>Нет данных для построения графика</p>
                    </div>
                )}
            </div>
        </div>
    );
});
